module.exports = __webpack_public_path__ + "188304addeb8e1e4969acf2448d7af28.png";